import { render, staticRenderFns } from "./carinfo-details.vue?vue&type=template&id=6e2779a4&scoped=true&"
import script from "./carinfo-details.vue?vue&type=script&lang=js&"
export * from "./carinfo-details.vue?vue&type=script&lang=js&"
import style0 from "./carinfo-details.vue?vue&type=style&index=0&id=6e2779a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2779a4",
  null
  
)

export default component.exports